import styles from "./products-skeleton.module.css";

export const ProductsSkeleton = ({ number }: {number: number;}) => {
  const items = Array.from(Array(Math.round(number)).keys());
  return <div className={styles.container}></div>;
};